export type U2000CriteriaTag = {
  value: string;
  label?: string;
  /** Données métier optionnelles (ex. tag wizard U3125) */
  meta?: unknown;
};

export function serializeTagsToCsv(tags: U2000CriteriaTag[]): string {
  return tags.map((t) => t.value).join(',');
}

export function serializeTagsToDisplayValue(tags: U2000CriteriaTag[]): string {
  return tags.map((t) => t.label ?? t.value).join(', ');
}

export function parseCsvToTags(value: string, displayValue?: string): U2000CriteriaTag[] {
  const values = String(value ?? '')
    .split(',')
    .map((s) => s.trim())
    .filter((s) => s.length > 0);

  if (!displayValue) {
    return values.map((v) => ({ value: v, label: v }));
  }

  const labels = String(displayValue)
    .split(',')
    .map((s) => s.trim());

  return values.map((v, i) => ({ value: v, label: labels[i] ?? v }));
}
